import { Prom, SubjectiveExamForm, TestKey } from "@rmh/defs";

export const PROM_TEST_TITLE_PREFIX = "8. PROM";

export const defaults = {
  examFormId: "ACBD-ACBD-ACBD",
  examTitle: "Step 8: Patient Reported Outcome Measures",
  order: 7,
};

export const defaultPlaceHolderProm: SubjectiveExamForm = {
  ...defaults,
  examFormTests: [
    {
      __typename: "ExamFormTestProm",
      updatedAt: new Date().toISOString(),
      testKey: TestKey.Quickdash,
      promBodyRegion: Prom.Quickdash,
      redToGreen: false,
      startAt: 1,
      promName: "Placeholder PROM",
      testTitle: `${PROM_TEST_TITLE_PREFIX} - Empty PROM`,
      questions: [
        {
          scaleStartLabel: "No",
          scaleEndLabel: "Yes",
          scaleLabels: ["No", "No", "No", "No", "No"],
          text: "Did user complete the PROM?",
        },
      ],
    },
  ],
};
